import styled from 'styled-components';

export const StatusWrapper = styled.div<{
  statusColor: any;
  children: any;
}>`
  background: ${props => props?.statusColor?.background};
  display: block;
  width: 100%;
  padding: 2px 16px;
  border-radius: 3px;
  text-align: center;

  p {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: ${props => props?.statusColor?.text};
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    display: inline-block;
    width: auto;
  }
`;
